import React from "react";
import {
  Column,
  DataGrid,
  Paging,
  Pager,
  Selection,
} from "devextreme-react/data-grid";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import UserInfo from "../UserInfo";
import uiInfo from "../ui-info";
import ContribuinteBox from "./contribuintes/ContribuinteBox";
import { Button, ScrollView } from "devextreme-react";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import axiosApi from "../api-axios";
import openReport from "../openReport";
import showError from "../AppServices";
import { criarContribuinteDs } from "../DataSources";

export default class ConferenciaAcordo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      prefeituraId: UserInfo.getPrefeitura(),
      listaAcordos: [],
      parcelas: [],
      dividas: [],
      popupVisivel: false,
      contribuinteId: undefined,
      contribuinteSequencial: undefined,
      somenteEmAtraso: false,
    };
    this.contribuinteDs = criarContribuinteDs();
    this.buscarAcordos = this.buscarAcordos.bind(this);
    this.imprimirNotificacao = this.imprimirNotificacao.bind(this);
    this.contribuinteBoxRef = React.createRef();
    this.onContribuinteSelecionadoPesq = this.onContribuinteSelecionadoPesq.bind(
      this
    );
    this.onSelection = this.onSelection.bind(this);
  }

  buscarAcordos() {
    axiosApi
      .post("conferencia_acordos/carregamento", { ...this.state })
      .then((response) => {
        if (response !== undefined) {
          this.setState({ listaAcordos: response.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  imprimirNotificacao() {
    axiosApi
      .post("conferencia_acordos/imprimir_notificacoes", {
        listaAcordos: this.state.listaAcordos,
        prefeituraId: this.state.prefeituraId,
      })
      .then((response) => {
        openReport(response.data.value);
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          showError(error.response.data);
        } else {
          showError(error);
        }
      });
  }

  onSelection(e) {
    if (e !== undefined) {
      this.setState({
        dividas: e.selectedRowsData[0].dividas,
        parcelas: e.selectedRowsData[0].parcelas,
      });
    }
  }

  onContribuinteSelecionadoPesq(e) {
    this.setState({
      contribuinteSequencial: e.row.data.sequencial,
      contribuinteId: e.row.data.id,
      popupVisivel: false,
    });
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <form onSubmit={this.buscarAcordos}>
          <Form
            id="frmPesquisa"
            formData={this.state}
            colCount={8}
            labelLocation={"top"}
          >
            <SimpleItem
              dataField="contribuinteSequencial"
              editorOptions={{
                buttons: [
                  {
                    name: "Pesquisar",
                    location: "after",
                    options: {
                      stylingMode: "text",
                      icon: "search",
                      onClick: () => {
                        this.setState({ popupVisivel: true });
                      },
                    },
                  },
                ],
              }}
              colSpan={3}
            >
              <Label text="Inscrição do Contribuinte" />
            </SimpleItem>
            <SimpleItem
              dataField="dataInicio"
              editorType="dxDateBox"
              editorOptions={{ width: "100%", useMaskBehavior: true }}
              colSpan={2}
            >
              <Label text="Data Inicial" />
            </SimpleItem>
            <SimpleItem
              dataField="dataFinal"
              editorType="dxDateBox"
              editorOptions={{ width: "100%", useMaskBehavior: true }}
              colSpan={2}
            >
              <Label text="Data Final" />
            </SimpleItem>
            <SimpleItem
              dataField="somenteEmAtraso"
              editorType="dxCheckBox"
              colSpan={1}
            >
              <Label text="Somente em Atraso" />
            </SimpleItem>
          </Form>
          <br />
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={150}
                text="Buscar Acordos"
                type="success"
                onClick={this.buscarAcordos}
              />
            </div>
          </div>
        </form>
        <br />
        <div
          style={{ display: this.state.listaAcordos.length > 0 ? "" : "none" }}
        >
          <Button
            text="Imprimir Notificações"
            type="success"
            onClick={this.imprimirNotificacao}
          />
          <h3>Acordos</h3>
          <DataGrid
            dataSource={this.state.listaAcordos}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            columnAutoWidth={true}
            wordWrapEnabled={window.innerWidth < 800}
            onSelectionChanged={(e) => this.onSelection(e)}
          >
            <Selection
              mode="single"
              selectAllMode="allPages"
              showCheckBoxesMode="always"
            />
            <Column
              type="buttons"
              fixed={true}
              fixedPosition={"left"}
              caption="Serviços"
              buttons={[
                {
                  text: "Imprimir DAM",
                  icon: "exportpdf",
                  onClick: (e) => {
                    axiosApi
                      .post("conferencia_acordos/imprimir_dams", {
                        acordoId: e.row.data.id,
                        prefeituraId: this.state.prefeituraId,
                      })
                      .then((response) => {
                        openReport(response.data.value);
                      })
                      .catch((error) => {
                        if (error.response && error.response.data) {
                          showError(error.response.data);
                        } else {
                          showError(error);
                        }
                      });
                  },
                },
              ]}
            />
            <Column
              dataField={"id"}
              caption={"#"}
              width={"80"}
              alignment={"center"}
            />
            <Column
              dataField={"exercicio"}
              caption={"Exercício"}
              alignment={"center"}
              width={"80"}
            />
            <Column
              dataField={"numeroCompleto"}
              caption={"Nº Acordo"}
              alignment={"center"}
            />
            <Column
              dataField={"dataLancamento"}
              caption={"Data"}
              alignment={"center"}
              dataType="date"
            />
            <Column
              dataField={"contribuinte.sequencial"}
              caption={"IMC"}
              width={"80"}
              alignment={"center"}
            />
            <Column dataField={"contribuinte.nome"} caption={"Contribuinte"} />
            <Column
              dataField={"contribuinte.documentoFormatado"}
              caption={"Contrib. Doc."}
            />
            <Column
              dataField={"imovel.sequencial"}
              caption={"IMI"}
              width={"80"}
              alignment={"center"}
            />
            <Column
              dataField={"parcelas.length"}
              caption={"Parcelas"}
              alignment={"center"}
            />
            <Column dataField={"pago"} caption={"Pago"} />
            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </div>
        <div
          style={{
            display: this.state.dividas.length > 0 ? "" : "none",
          }}
        >
          <h3>Parcelas de Origem</h3>
          <DataGrid
            dataSource={this.state.dividas}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            columnHidingEnabled={true}
            columnAutoWidth={true}
            wordWrapEnabled={window.innerWidth < 800}
          >
            <Column dataField={"id"} caption={"#"} alignment={"center"} />
            <Column
              dataField={"ano"}
              caption={"Exercício"}
              alignment={"center"}
            />
            <Column
              dataField={"receita.origem"}
              caption={"Origem"}
              alignment={"center"}
            />
            <Column dataField={"parcela"} caption={"Parcela"} />
            <Column dataField={"damId"} caption={"DAM"} alignment={"center"} />
            <Column
              dataField={"imovel.sequencial"}
              caption={"Imóvel"}
              alignment={"center"}
            />
            <Column dataField={"valorOriginal"} caption={"Valor Original"} />
            <Column dataField={"multa"} caption={"Multa"} />
            <Column dataField={"juros"} caption={"Juros"} />
            <Column dataField={"total"} caption={"Total"} />
            <Column dataField={"pago"} caption={"Pago"} />
            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </div>
        <div style={{ display: this.state.parcelas.length > 0 ? "" : "none" }}>
          <h3>Parcelas do Acordo</h3>
          <DataGrid
            dataSource={this.state.parcelas}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            columnHidingEnabled={true}
            columnAutoWidth={true}
            wordWrapEnabled={window.innerWidth < 800}
          >
            <Column
              dataField={"sequencial"}
              caption={"#"}
              alignment={"center"}
            />
            <Column
              dataField={"exercicio"}
              caption={"Exercício"}
              alignment={"center"}
            />
            <Column
              dataField={"numeroParcelaStr"}
              caption={"Parcela"}
              alignment={"center"}
            />
            <Column
              dataField={"dataDeVencimento"}
              caption={"Data de Vencimento"}
              dataType="date"
              alignment={"center"}
            />
            <Column
              dataField={"valor"}
              caption={"Valor"}
              alignment={"center"}
            />
            <Column dataField={"situacaoPagto"} caption={"Situação"} />
            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </div>
        <div
          style={{
            marginTop: "10px",
            display: "flex",
            justifyContent: "center",
          }}
        ></div>
        <Popup
          visible={this.state.popupVisivel}
          onHiding={() => {
            this.setState({ popupVisivel: false });
          }}
          dragEnabled={false}
          closeOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar Contribuinte"
        >
          <ScrollView showScrollbar={"always"}>
            <ContribuinteBox
              onSelecionado={this.onContribuinteSelecionadoPesq}
              ref={this.contribuinteBoxRef}
            />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupVisivel: false }),
            }}
          ></ToolbarItem>
        </Popup>
      </div>
    );
  }
}
